import { FC, forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import { Badge } from './Badge'
import { CONTAINER_SIZES } from './constants'
import { ItemWithBadgeProps } from './types'

export const ItemWithBadge: FC<ItemWithBadgeProps> = forwardRef(
  ({ children, badge, className, size = 'md' }, ref) => {
    return (
      <div
        className={twMerge(
          'relative inline-flex items-center justify-center',
          CONTAINER_SIZES[size],
          className,
        )}
      >
        {children}
        {badge && <Badge {...badge} />}
      </div>
    )
  },
)

ItemWithBadge.displayName = 'ItemWithBadge'
